<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{ advertisementId == null ? $t("CREATE_NEW_ADVERTISEMENT") : $t("edit_advertisement") }}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="index.html">{{ $t("general") }}</a>
              </li>
              <li class="breadcrumb-item active">
                {{ $t("advertisement_management") }}
              </li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li>
                  <a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title=""
                    data-original-title="Tables"
                    ><i data-feather="inbox"></i></a>
                </li>
                <li>
                  <a
                    href="javascript:void(0)"
                    data-container="body"
                    data-bs-toggle="popover"
                    data-placement="top"
                    title=""
                    data-original-title="Chat"
                    ><i data-feather="message-square"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="javascript:void(0)"
                    data-container="body"
                    data-bs-toggle="popover"
                    data-placement="top"
                    title=""
                    data-original-title="Icons"
                    ><i data-feather="command"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="javascript:void(0)"
                    data-container="body"
                    data-bs-toggle="popover"
                    data-placement="top"
                    title=""
                    data-original-title="Learning"
                    ><i data-feather="layers"></i
                  ></a>
                </li>
                <li>
                  <a href="javascript:void(0)"
                    ><i class="bookmark-search" data-feather="star"></i
                  ></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'" />
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-lg-9">
          <app-icon-list
            :type="'APP'"
            :title="$t('choose_app_for_ad')"
            :fetchedObject="selectedApp"
            @pushSelectedApp="pushSelectedApp"
            :objects="apps"
            :showcheckbox="true"
          ></app-icon-list>

          <advertisement-select
            :selectedApp="selectedApp"
            :fetchedPlacementType="selectedPlacementType"
            :fetchedPlacement="selectedPlacement"
            :fetchedDescriptions="selectedDescriptions"
            :fetchedImages="selectedImages"
            :fetchedTargetUrl="advertisement.targetUrl"
            :fetchedTargetUrlType="advertisement.targetUrlType"
            :fetchedTargetAccountId="advertisement.targetAccountId"
            :fetchedLocation="{lng:advertisement.targetLongitude,lat:advertisement.targetLatitude}"
            @getSelectedPlacement="getSelectedPlacement"
            @getSelectedPlacementType="getSelectedPlacementType"
            @getTargetLocation="getTargetLocation"
            @getDescriptions="getDescriptions"
            @getTargetUrl="getTargetUrl"
            @getImages="getImages"
            @getSelectedSpecificData="getSelectedSpecificData"
            @getTargetAccountId="getTargetAccountId"
            :placementTypes="placementTypes"
            :placements="placements"
          ></advertisement-select>


            
          <div class="card">
              <div class="card-header">
                <h5>{{ $t("advertisement_options") }}</h5>
              </div>
              <div class="card-body">
                <div class="form theme-form">
                <div class="row">
                  <div class="col-12 row">
                    <div class="col-12 py-0">
                      <div class="mb-3 w-100">
                        <label>{{ $t("designation") }}*</label>
                        <v-text-field
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          hide-details="auto"
                          type="text"
                          v-model="advertisement.name"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="col-6 py-0">
                      <div class="mb-3 w-100">
                        <label>{{ $t("bidding_cpm") }}</label>&nbsp;
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon size="16" v-on="on">fa fa-info-circle</v-icon>
                          </template>
                          <span>{{ $t("bidding_cpm_explanation") }}</span><br>
                          <span v-if="impressions != null && impressions.minimumCPM > 0">{{ $t("bidding_cpm_min_hint", {price: $formatCurrency(impressions.minimumCPM)}) }}</span>
                        </v-tooltip>
                        <v-text-field
                          hide-details="auto"
                          dense
                          outlined
                          class="datainput justify-content-end align-self-center pb-1"
                          id="biddingCPM"
                          type="number"
                          v-model="advertisement.biddingCPM"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="col-6 py-0">
                      <div class="mb-3">
                        <label>{{ $t("maxCostPerDay") }}</label>&nbsp;
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon size="16" v-on="on">fa fa-info-circle</v-icon>
                          </template>
                          <span>{{ $t("maxCostPerDay_hint") }}</span><br>
                        </v-tooltip>
                        <input
                          class="form-control"
                          type="number"
                          v-model="advertisement.maxCostPerDay"
                        />
                      </div>
                    </div>
                    <div class="col-6 py-0 align">
                      <div class="mb-3 w-100">
                        <label>{{ $t("startdate") }}</label>
                        <input
                          class="form-control digits"
                          type="datetime-local"
                          v-model="advertisement.startDate"
                        />
                      </div>
                    </div>
                    <div class="col-6 py-0 align">
                      <div class="mb-3 w-100">
                        <label>{{ $t("enddate") }}</label>
                        <input
                          class="form-control digits"
                          type="datetime-local"
                          v-model="advertisement.endDate"
                        />
                      </div>
                    </div>
                    <div class="col-6 py-0 align" v-if="$rights.includes('TENANT_INDEPENDENCE')">
                      <div class="mb-3 w-100">
                        <label>{{ $t("backfilling_ad") }}</label>&nbsp;
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon size="16" v-on="on">fa fa-info-circle</v-icon>
                          </template>
                          <span>{{ $t("backfilling_ad_advice") }}</span><br>
                        </v-tooltip><br>
                        <input type="checkbox" v-model="advertisement.backfillingAd">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>

          <filter-form
            v-model="filter"
            :title="$t('choose_audience_for_ad')"
            :saveable="false"
          ></filter-form>
        </div>
        <div class="col-12 col-lg-3">
          <div class="result-container">
            <div class="top-right" v-show="impressionsResultLoading">
              <div class="top-right-loading">
                  <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-0">
                <h3 @click="result()">{{ $t("result") }}</h3>
              </div>
              <div class="card-body pb-2">
                <h6 class="text-left" v-show="(impressions.durationDays != null && impressions.durationDays > 0) || (impressions.durationHours != null && impressions.durationHours > 0)">{{ $t("advertisement_duration") }}</h6>
                <div class="row ma-0">
                  <p class="text-right col-6 mb-0 pa-0 result-value text-h6" v-show="impressions.durationDays != null && impressions.durationDays > 0">
                    {{
                      impressions.durationDays == null
                        ? 0
                        : impressions.durationDays
                    }}
                  </p>
                  <p class="text-left col-6 mb-0 pl-2 pa-0 text-h6" v-show="impressions.durationDays != null && impressions.durationDays > 0">{{ $t("days") }}</p>
                  <p class="text-right col-6 mb-0 pa-0 result-value text-h6" v-show="impressions.durationHours != null && impressions.durationHours > 0">
                    {{
                      impressions.durationHours == null
                        ? 0
                        : impressions.durationHours
                    }}
                  </p>
                  <p class="text-left col-6 mb-0 pl-2 pa-0 text-h6" v-show="impressions.durationHours != null && impressions.durationHours > 0">{{ $t("hours") }}</p>
                </div>
                <h6 class="text-left">{{ $t("expected_impressions") }}*</h6>
                <div class="row ma-0">
                  <p class="text-right col-6 mb-0 pa-0 result-value text-h6">
                    {{ impressions.expectedImpressionsPerDay }}
                  </p>
                  <p class="text-left col-6 mb-0 pl-2 pa-0 text-h6">{{ $t("per_day") }}</p>
                  <p class="text-right col-6 mb-0 pa-0 result-value text-h6">
                    {{ impressions.expectedImpressionsPerWeek }}
                  </p>
                  <p class="text-left col-6 mb-0 pl-2 pa-0 text-h6">
                    {{ $t("per_week") }}
                  </p>
                </div>
                <h6 class="text-left">{{ $t("expected_price") }}*</h6>
                <div class="row ma-0">
                  <p class="text-right col-6 mb-0 pa-0 result-value text-h6">
                    {{ $formatCurrency(impressions.expectedPricePerDay) }} €
                  </p>
                  <p class="text-left col-6 mb-0 pl-2 pa-0 text-h6">{{ $t("per_day") }}</p>
                  <p class="text-right col-6 mb-0 pa-0 result-value text-h6">
                    {{ $formatCurrency(impressions.expectedPricePerWeek) }} €
                  </p>
                  <p class="text-left col-6 mb-0 pl-2 pa-0 text-h6">
                    {{ $t("per_week") }}
                  </p>
                </div>
                <div class="row justify-content-center">
                  <v-btn
                    size="small"
                    class="campaign-button mt-8"
                    variant="flat"
                    rounded="lg"
                    @click="save()"
                    >{{ advertisementId != null ? $t("edit_campaign") : $t("create_campaign") }}</v-btn
                  >
                </div>
                <p class="campaign-hint mt-6">
                  * {{ $t("create_campaign_hint") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { MapPinIcon, PlusSquareIcon } from "vue-feather-icons";
import AppIconCheck from "./widget/AppIconCheck.vue";
import AppIconList from "./widget/AppIconList.vue";
import AdvertisementSelect from "./widget/AdvertisementSelect.vue";
import FilterForm from "./widget/FilterForm.vue";
import DatePicker from "./widget/DatePicker.vue";

export default {

  props: {
    advertisementId: Number,
  },

  components: {
    apexcharts: VueApexCharts,
    MapPinIcon,
    PlusSquareIcon,
    DatePicker,
    AppIconCheck,
    AdvertisementSelect,
    FilterForm,
  },
  data() {
    return {
      editMode: false,

      impressionsResultLoading: false,

      filter: {
        name: "", //
        tenantId: null, //
        language: "", //
        longitude: "",
        latitude: "",
        radius: 1,
        audienceVehicleMake: null,
        audienceVehicleModel: null,
        audienceVehicleYearFrom: 0, //
        audienceVehicleYearTo: 0, //
        audienceVehicleCount: 0, //
        createdPostsCount: 0, //
        createdTripsCount: 0, //
        memberSince: null, //
        lastCreatedPostFrom: null, //
        lastCreatedPostTo: null, //
        likedHashTags: "",
      },

      advertisement: {
        name: "",
        startDate: this.dateToString(this.getDates()),
        endDate: this.dateToString(this.getDates(true)),
        maxCostPerDay: 0,
        biddingCPM: 0,
        targetUrl: "",
        targetUrlType: "",
        targetLongitude: "",
        targetLatitude: "",
        targetAccountId:"",
        imageUrls: {},
        videoUrls: {},
        descriptions: {},
        placementId: null,
        placementTypeId:null,
        targetAudiences: [],
        backfillingAd: false,
      },

      images: [],

      irrelevantImpressionRequestParameters: [
        "name",
        "targetUrl",
        "targetUrlType",
        "targetLongitude",
        "targetLatitude",
        "descriptions",
      ],

      selectedApp: null,
      selectedPlacementType: null,
      selectedPlacement: null,
      selectedFilter: null,
      selectedSpecificData: null,
      selectedDescriptions:null,
      selectedImages:null,

      fixedTargetGroupAttributes: ["id", "appId", "tenant", "targetAudienceConfiguration", "createdAt", "createdBy", "editedAt", "editedBy", "longitude", "latitude", "radius", "deleted", "name", "app", "createdAtFormatted", "editedAtFormatted", "tenantId"],

      toppanel: [0, 1],
      bottompanel: [0,1],

      tenants: [],
      apps: [],
      placementTypes: [],
      placements: [],
      impressions: {
        duration: 0,
        expectedImpressionsPerDay: 0,
        expectedImpressionsPerWeek: 0,
        expectedPricePerDay: 0,
        expectedPricePerWeek: 0,
        minimumCPM: 0,
        minimumCPC: 0,
      },

      map: {
        center: {
          latitude: 52.218945,
          longitude: 13.439067,
        },
        zoom: 10,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },

      boundaries: [],
    };
  },

  computed: {
    advertisement_str: function() {
      return JSON.stringify(this.advertisement);
    },
  },

  watch: {
    'advertisement.startDate': {
      handler(val){
        console.log(val);
      },
    },
    filter: {
      handler(val){
        this.selectedFilter = val;

        const targetAudienceConfiguration = Object.assign({}, val);
        for (let i = 0; i < this.fixedTargetGroupAttributes.length; i++) {
          const attr = this.fixedTargetGroupAttributes[i];
          delete targetAudienceConfiguration[attr];
        }
        if(targetAudienceConfiguration.audienceVehicleMake == null) targetAudienceConfiguration.audienceVehicleModel = null;
        this.filter.targetAudienceConfiguration = JSON.stringify(targetAudienceConfiguration);
      },
      deep:true,
    },
    "impressions.minimumCPM": function(val) {
      if (this.advertisement.biddingCPM < val) {
        this.advertisement.biddingCPM = Math.round(val * 100) / 100;
      }
    },
    advertisement_str: {
      handler(newValue_str, oldValue_str) {
        let newVal = JSON.parse(newValue_str);
        let oldValue = JSON.parse(oldValue_str);
        // console.log(newVal.placementId, oldValue.placementId)
        var sendUpdate = false;
        for (const [key, value] of Object.entries(newVal)) {
          // console.log("key", key);
          var irrelevant = false;
          for (
            let i = 0;
            i < this.irrelevantImpressionRequestParameters.length;
            i++
          ) {
            const irrelevantParam = this.irrelevantImpressionRequestParameters[
              i
            ];
            // console.log("irrelevantParam", irrelevantParam);
            if (key == irrelevantParam) {
              irrelevant = true;
              break;
            }
          }
          if (irrelevant) continue;
          // console.log("oldValue[key]", oldValue[key]);
          // console.log("value", value);
          if (JSON.stringify(oldValue[key]) != JSON.stringify(value)) {
            sendUpdate = true;
            break;
          }
        }
        if (sendUpdate) {
          this.getResult();
        }
      },
      deep: true,
    },
    selectedApp: function(val) {
      if (val != null) {
        this.fetchplacementTypes();
      } else if (val == null) {
        this.placementTypes = [];
        this.placements = [];
      }
    },
    selectedPlacementType: function(val) {
      if(val != null){
        this.advertisement.placementTypeId = val.id;
      }
      if (Object.keys(val).length != 0) {
        this.placements = val.activePlacements;
      } else if (Object.keys(val).length == 0) {
        this.placements = [];
      }
    },
    selectedPlacement: function(val) {
      if (val != null) {
        this.advertisement.placementId = val.id;
      }
    },
    selectedFilter: function(val) {
      if (val.tenantId != null) {
        this.advertisement.tenantId = val.tenantId;
      }

      val.audienceVehicleYearFrom =
        val.audienceVehicleYearFrom < 1800 ? null : val.audienceVehicleYearFrom;
      val.audienceVehicleYearTo =
        val.audienceVehicleYearTo < 1800 ? null : val.audienceVehicleYearTo;

      var arr = [];
      arr.push(val);
      this.advertisement.targetAudiences = arr;
    },
  },

  created(){
  },

  mounted() {
    this.fetchApps();
    if (this.advertisementId != null) {
      this.editMode = true;
      this.fetchEditingAdvertisement();
    } else {
      this.fetchBudgetAndShowWarning();
    }
  },

  methods: {
    getDates(enddate = false){
      var result = new Date();
      if(enddate){
        result.setDate(result.getDate() + 365);
      }
      result.setSeconds(0);
      result.setMilliseconds(0);
        return result;
    },
    _validate() {
      if (this.advertisement.name == '' || this.advertisement.name == null) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("designation") }));
        return false;
      }
      if(this.selectedFilter != null && this.selectedFilter.id == null || this.selectedFilter != null && this.selectedFilter.id == undefined){
        if(this.selectedFilter.name == "" ||this.selectedFilter.name == null){
          this.$noty.error(this.$t("empty_value_for", { name: this.$t("designation"),for: this.$t('targetgroups') }));
          return false;
        }
      }

      return true;
    },
    getResult() {
      if(this.advertisement.placementId == null) return;
      var _this = this;
      this.impressionsResultLoading = true;
      this.$axios
        .post("/api/advertisement/impressions", this.advertisement)
        .then(function(response) {
          _this.impressions = response.data;
          _this.impressionsResultLoading = false;
          // _this.$forceUpdate();
        })
        .catch(err => console.error(err));
    },
    result() {
      console.log({
        advertisement: this.advertisement,
        app: this.selectedApp,
        placementType: this.selectedPlacementType,
        placement: this.selectedPlacement,
        filter: this.filter,
        specificData: this.selectedSpecificData,
      });
    },
    getTargetAccountId(event){
      this.advertisement.targetAccountId = event;
    },
    getImages(event) {
      var obj = Object.assign({}, event);
      for (const [key, value] of Object.entries(obj)) {
        if(Array.isArray(obj[key]) && obj[key].length == 0){
          obj[key] = null;
        }else if(Array.isArray(obj[key]) && obj[key].length == 1){
          obj[key] = obj[key][0];
        }
      }
      this.advertisement.imageUrls = obj;
    },
    getTargetLocation(event) {
      if (event == null) {
        this.advertisement.targetLongitude = event.longitude;
        this.advertisement.targetLatitude = event.latitude;
        // this.$forceUpdate();

      } else if (event != null) {
        var obj = Object.assign({}, event);
        this.advertisement.targetLongitude = obj.longitude;
        this.advertisement.targetLatitude = obj.latitude;
      }
    },
    getDescriptions(event) {
      var obj = Object.assign({}, event);
      this.advertisement.descriptions = obj;
    },
    getFilter(event) {
      console.log(event);

      if (event == null) {
        this.selectedFilter = event;
      } else if (event != null) {
          var obj = Object.assign({}, event);
          this.selectedFilter = obj;
      }
      
    },
    getTargetUrl(event) {
      if (event == null) {
        this.advertisement.targetUrl = event.targetUrl;
        this.advertisement.targetUrlType = event.targetUrlType;
        // this.$forceUpdate();
      } else if (event != null) {
        var obj = Object.assign({}, event);
        this.advertisement.targetUrl = obj.targetUrl;
        this.advertisement.targetUrlType = obj.targetUrlType;
      }
    },
    getSelectedSpecificData(event) {
      if (event == null) {
        this.selectedSpecificData = event;
        // this.$forceUpdate();
      } else if (event != null) {
        var obj = Object.assign({}, event);
        this.selectedSpecificData = obj;
      }
    },
    getSelectedPlacement(event) {
      if (event == null) {
        this.selectedPlacement = event;
        // this.$forceUpdate();
      } else if (event != null) {
        var obj = Object.assign({}, event);
        this.selectedPlacement = obj;
      }
    },
    getSelectedPlacementType(event) {
      if (event == null) {
        this.selectedPlacementType = event;
        // this.$forceUpdate();
      } else if (event != null) {
        var obj = Object.assign({}, event);
        this.selectedPlacementType = obj;
      }
    },
    pushSelectedApp(event) {
      if (event == null) {
        this.selectedApp = event;
        // this.$forceUpdate();
      } else if (event != null) {
        var obj = Object.assign({}, event);
        this.selectedApp = obj;
      }
    },
    fetchEditingAdvertisement() {
      var _this = this;
      this.$axios
        .get("/api/advertisement/" + this.advertisementId)
        .then(function(response) {
          _this.selectedPlacementType = Object.assign({}, response.data.placementType);
          _this.selectedApp = Object.assign({}, response.data.placement.app);
          _this.selectedPlacement = Object.assign({}, response.data.placement);
          _this.selectedDescriptions = Object.assign({}, response.data.descriptionsMap);
          _this.selectedImages = Object.assign({}, response.data.imageUrlsMap);
          _this.advertisement = response.data;
          if(response.data.targetAudiences.length == 1){
            _this.filter = Object.assign({}, response.data.targetAudiences[0]);
          }
          if(response.data.startDate == null) _this.advertisement.startDate = _this.dateToString(_this.getDates());
          if(response.data.endDate == null) _this.advertisement.endDate = _this.dateToString(_this.getDates(true));
        })
        .catch(this.onError);
    },
    fetchApps(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get("/api/app/")
        .then(function(response) {
          _this.apps = response.data.content;
          // _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchplacementTypes(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get("/api/placementType/app/" + _this.selectedApp.id)
        .then(function(response) {
          _this.placementTypes = response.data.content;
          // _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    save() {
      if(!this._validate()) return;
      var ad = Object.assign({}, this.advertisement);
      ad.videoUrls = {}; // TODO: Video Upload not yet supported
      for(var i = 0; i < ad.targetAudiences.length; i++){
        if(Array.isArray(ad.targetAudiences[i].likedHashTags)){
          ad.targetAudiences[i].likedHashTags = "";
        }
      }
      if (this.editMode) {
        this.updateAdvertisement(ad);
      } else {
        this.createAdvertisement(ad);
      }
    },
    createAdvertisement(advertisement) {
      var _this = this;
      this.$axios
        .post("/api/advertisement", advertisement)
        .then(function(response) {
          _this.$noty.success(_this.$t("advertisement_created"));
          _this.$router.push("/advertisements");
        })
        .catch(this.onError);
    },
    updateAdvertisement(advertisement) {
      var _this = this;
      this.$axios
        .put("/api/advertisement/" + this.advertisementId, advertisement)
        .then(function(response) {
          _this.$noty.success(_this.$t("advertisement_edited"));
          _this.$router.push("/advertisements");
        })
        .catch(this.onError);
    },
    fetchBudgetAndShowWarning() {
      var _this = this;
      this.$axios
        .get("/api/purchase/budget")
        .then(function (response) {
          if(response.data == null || response.data == 0){
            _this.$noty.warning(_this.$t("charge_account_first_warning"));
          }
        })
        .catch(this.onError);
    },
    logError(error) {
      console.log(error);
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null
      ) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    dateToString(date) {

      const stringValue = date.toISOString();

      const dotIndex = stringValue.indexOf('.');

      if (dotIndex < 0) {
          return stringValue;
      }

      return stringValue.slice(0, dotIndex);
    },
    finalize() {
      progressIndicator.hidden = true;
    },
  },
};
</script>

<style scoped>
.campaign-button {
  text-transform: none !important;
  background-color: #2f3452 !important;
  color: white !important;
}

.campaign-hint {
  font-size: 10px !important;
}

.result-value,
.card-header h1,
.card-header > h2,
.card-header > h3,
.card-header > h4,
.card-header > h5 {
  color: #2f3452 !important;
  text-transform: none !important;
}
</style>
